export enum ConfigStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
